/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EntityAuditLogDto { 
    tableName?: string | null;
    entityDisplayName?: string | null;
    propertyName?: string | null;
    originalValue?: string | null;
    newValue?: string | null;
    resolvedOriginalValue?: string | null;
    resolvedNewValue?: string | null;
    changedBy?: string | null;
    changeTime?: string;
}

